module.exports = __webpack_public_path__ + "static/meta/sqs/2020/layout_metadata.0db76a0.tsv";


//////////////////
// WEBPACK FOOTER
// ./src/components/sqs/2020/meta/layout_metadata.tsv
// module id = xGqf
// module chunks = 0